
export function getStatsData(){
    const json= sessionStorage.getItem("stats");
    if(json)
        return JSON.parse(json);
}